<template>
    <user-refbooks :api="api" :drop-down-api="dropDownApi" :objid="objid" objname="kr_numobj" />
</template>
<script setup>
import UserRefbooks from '@/views/nsi/components/user-refbooks.vue';
import { useRoute } from 'vue-router';

const route = useRoute();
const objid = route.params.id;
//TODO добавить свои API
const api = {
    select: 'counteragent./contract/user-attributes/get',
    save: 'counteragent./contract/user-attributes/set',
};
const dropDownApi = { select: 'counteragent./contract/user-attributes/values/get' };
</script>
